/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, max: NonNullable<unknown> }} Sub_Cancel_Free_Up_StorageInputs */



/**
* | output |
* | --- |
* | "Free up storage ({used} used, {max} max on Free)" |
*
* @param {Sub_Cancel_Free_Up_StorageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_cancel_free_up_storage = /** @type {((inputs: Sub_Cancel_Free_Up_StorageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Cancel_Free_Up_StorageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Speicher freigeben (${i?.used} belegt, ${i?.max} max. bei Free)`)
	return /** @type {LocalizedString} */ (`Free up storage (${i?.used} used, ${i?.max} max on Free)`)
});